import * as type from '../actions/types';

const initialState = {
  profile: [],
  loading: false,
  error: null,
}

export default function getProfileData(state = initialState, action) {
  switch (action.type) {
    case type.GET_PROFILE_DATA_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case type.GET_PROFILE_DATA_SUCCESS:
      console.log('Profile reducer - GET_PROFILE_DATA_SUCCESS');
      console.log('Previous profile state:', state.profile);
      console.log('New profile data from API:', action.data);
      console.log('is_pro_provider from API:', action.data?.is_pro_provider);
      
      return {
        ...state,
        loading: false,
        profile: action.data,
        // error:action.errors
      }
    case type.GET_PROFILE_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
    case type.UPDATE_PROFILE_SUBSCRIPTION_STATUS:
      console.log('Profile reducer - UPDATE_PROFILE_SUBSCRIPTION_STATUS');
      console.log('Previous profile state:', state.profile);
      console.log('Setting is_pro_provider to:', action.isProProvider);
      
      const updatedProfile = state.profile ? { ...state.profile, is_pro_provider: action.isProProvider } : state.profile;
      console.log('Updated profile state:', updatedProfile);
      
      return {
        ...state,
        profile: updatedProfile,
      }
    default:
      return state
  }
}